import { render, staticRenderFns } from "./ReplaceCertificate.vue?vue&type=template&id=28e97581&scoped=true&"
import script from "./ReplaceCertificate.vue?vue&type=script&lang=js&"
export * from "./ReplaceCertificate.vue?vue&type=script&lang=js&"
import style0 from "./ReplaceCertificate.vue?vue&type=style&index=0&id=28e97581&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e97581",
  null
  
)

export default component.exports